import React, { useState, useEffect } from "react";
import ReactDatePicker from "react-datepicker";
import Select from "react-select";
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Table,
  Col,
  Row,
  FormGroup,
  Popover,
  PopoverHeader,
  PopoverBody,
  Alert,
  ButtonGroup,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { createQuestionsChunks, SELECT_NO_OF_TRIVVYS } from "../data";
import moment from "moment";
import Toggle from "react-toggle";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import { snapToQuarterHour } from "../../../../utils/dateUtils";
import * as actionCreators from "../../../../modules/actions";
import { FaArrowRight } from "react-icons/fa6";
import { BiMailSend, BiTrashAlt } from "react-icons/bi";
import {
  contvertHTMLToPlain,
  profilePicValidityCheck,
} from "../../../../utils/constants";
import CheckBox from "rc-checkbox";
import { toastContainer } from "../../../../utils/toast";
import {
  TRIVIA_SHARE_PRIVACY_OPTIONS,
  TRIVIA_USER_IDENTIFICATION_OPTIONS,
} from "../../data";
import ReactTooltip from "react-tooltip";
import {
  ActionLayoutData,
  ActionLayoutHeading,
  LayoutData,
  LayoutHeading,
  LayoutRow,
} from "../../../../pages/weekly-wins/TableLayoutComponents";
import { isMobile } from "../../../../utils/deviceInfo";
import { connect } from "react-redux";
import { MdOutlineMobileFriendly } from "react-icons/md";
import { withRouter } from "react-router";

const questionOptions = [
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
];

function ScheduleQuestionsModal({
  open,
  onClose,
  library,
  onScheduleSuccess,
  goToTrivvyTab,
  user,
  setLibraryScheduleLoader,
  embeddedInTrivvyCreateModal,
  setImportTemplateAddedTrivvys,
  onBack,
  ...props
}) {
  const isOwner = false;
  const [allUsersChecked, setAllUsersChecked] = useState(false);
  const [formData, setFormData] = useState({
    questionsCount: null,
    trivvyParts: [],
    noOfTrivvys: 0,
  });
  const [usersListAll, setUsersListAll] = useState([]);

  const [newSelectedUser, setNewSelectedUser] = useState(null);
  const [shareTrivvyViaSMS, setShareTrivvyViaSMS] = useState(false);
  const [shareTrivvyViaEmail, setShareTrivvyViaEmail] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [selectToggle, setSelectToggle] = useState("ALL");
  const [
    notifyAdminAfterTrivvyPublished,
    setNotifyAdminAfterTrivvyPublished,
  ] = useState(false);

  const [triviaShareAndPrivacy, setTriviaShareAndPrivacy] = useState({
    sharedWithUsers: [],
    privacy: "PUBLIC",
  });

  const [userIdentification, setUserIdentification] = useState("EMAIL");

  const formatSelectedUsers = (data) => {
    const d = data.map((e) => {
      if (e.firstName && e.lastName) {
        return {
          label: `${e.firstName}, ${e.lastName}`,
          value: e._id || e.userId,
          permissions: 0,
          profilePic: e.profilePic,
          firstName: e.firstName,
          lastName: e.lastName,
          date: e.date,
          email: e.email,
          mobileNumber: e.mobileNumber,
        };
      } else if (e) {
        let name =
        e.firstName && e.firstName.length > 0 ? e.firstName : e.lastName && e.lastName.length > 0 ? e.lastName : e.email
        return { 
          label: `${e.firstName}, ${e.lastName}`,
          value: e._id || e.userId,
          permissions: 0,
          profilePic: e.profilePic,
          firstName: e.firstName,
          lastName: e.lastName,
          date: e.date,
          email: e.email,
          mobileNumber: e.mobileNumber,
         };
      }
    });

    return d;
  };

  useEffect(() => {
    axios
      .get(url.userListArray)
      .then((response) => {
        setUsersData(response.data.data);
        const users = formatSelectedUsers(response.data.data);
        setUsersListAll(users);
        setUsersList(users);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const changeTrivvyName = (value, index) => {
    const partsArr = [...formData.trivvyParts];

    partsArr[index].name = value;

    setFormData({
      ...formData,
      trivvyParts: partsArr,
    });
  };
  const changeTrivvyScheduledDate = (value, index) => {
    const partsArr = [...formData.trivvyParts];

    partsArr[index].scheduledDate = value;

    setFormData({
      ...formData,
      trivvyParts: partsArr,
    });
  };

  const [smsUsers, setSmsUsers] = useState(0);

  const buttonDisabled = () => {
    console.log(formData)
    if (formData.noOfTrivvys && formData.trivvyParts.length) {
      if (formData.trivvyParts.length === formData.noOfTrivvys) {
        for (const itm of formData.trivvyParts) {
          if (
            itm.scheduledDate &&
            itm.name 
          ) {
          } else {
            return true;
          }
        }
      } else {
        return true;
      }
    } else {
      return true;
    }

    return false;
  };

  const handleGenerateTrivvys = () => {
    const trivvysDataFormatted = formData.trivvyParts.map((part, index) => {
      const users_share = triviaShareAndPrivacy.sharedWithUsers.map((itm) => {
        const user = usersData.find((x) => x._id == itm.value);
        const mediums = [];

        if (user.mobileNumber && shareTrivvyViaSMS) {
          mediums.push("SMS");
        }

        if (shareTrivvyViaEmail) {
          mediums.push("EMAIL");
        }
        if (user) {
          return {
            firstName: user.firstName,
            lastName: user.lastName,
            userId: user._id,
            date: itm.date ? itm.date : new Date(),
            genderPronoun: user.genderPronoun,
            profilePic: user.profilePic,
            email: user.email,
            mobileNumber: user.mobileNumber,
            shareMediums:
              itm.shareMediums && itm.shareMediums.length > mediums.length
                ? itm.shareMediums
                : mediums,
          };
        } else {
          return {
            userId: itm.value,
            firstName: itm.label,
            lastName: "",
            date: itm.date ? itm.date : new Date(),
          };
        }
      });

      return {
        ...part,
        hasParts: index + 1,
        privacy: triviaShareAndPrivacy.privacy,
        shareTrivvyViaEmail: shareTrivvyViaEmail,
        shareTrivvyViaSMS: shareTrivvyViaSMS,
        sharedWithUsers: users_share,
        userIdentificationOptions: [userIdentification],
        isPublished: moment(part.scheduledDate).isSameOrBefore(moment(), "hour")
          ? true
          : false,
        notifyAdminAfterTrivvyPublished: notifyAdminAfterTrivvyPublished,
      };
    });

    console.log(trivvysDataFormatted);

    const payload = {
      questionsCountPerTrivvy: formData.questionsCount,
      noOfTrivvys: formData.noOfTrivvys,
      trivvyPartsArray: trivvysDataFormatted,
      libraryId: library._id,
      sourceUrl: library.s3Url||library.webUrl,
      embeddedInTrivvyCreateModal
    };

    // if(embeddedInTrivvyCreateModal){
    //   axios
    //   .post(url.generateLibraryTrivvys, payload)
    //   .then(({ data }) => {
    //     // for (const item of data.data) {
    //     //   if(item.isPublished){
    //     //     axios.put(url.shareTrivia(item._id), {
    //     //       sharedWithUsers: item.sharedWithUsers,
    //     //       privacy: item.privacy,
    //     //       shareTrivvyViaSMS:item.shareTrivvyViaSMS,
    //     //       shareTrivvyViaEmail:item.shareTrivvyViaEmail,
    //     //     });
    //     //   }
    //     // }
    
    //     if(setImportTemplateAddedTrivvys){
    //       setImportTemplateAddedTrivvys(data.data)
    //     }
    //       toastContainer("Trivvys generated successfully", "success");
    //   })
    //   .catch((err) => {
    //     setLibraryScheduleLoader({
    //       display: false,
    //       loaderApiData: null,
    //       minimize:false
    //     });
    //     toastContainer("Error occured while scheduling trivvys", "error");
    //   });
    // }
    
    // else{
     
    // }


    if(embeddedInTrivvyCreateModal){
      setLibraryScheduleLoader({
        display: true,
        loaderApiData: payload,
        minimize: false,
        
      });
      if(onClose){
        onClose();
      }
    }else{
      setLibraryScheduleLoader({
        display: true,
        loaderApiData: payload,
        minimize: false,
        
      });
      if(onClose){
        onClose();
      }
    }

   
  };

  const onUserSelect = (u) => {
    console.log(u);
    setNewSelectedUser(u);

    if (u && u.mobileNumber && u.mobileNumber.length > 0) {
      let userCellCount = smsUsers + 1;
      setSmsUsers(userCellCount);
    }

    const array = [u, ...triviaShareAndPrivacy.sharedWithUsers];
    if (u) {
      setTriviaShareAndPrivacy({
        ...triviaShareAndPrivacy,
        sharedWithUsers: array,
      });
    }
  };

  const removeUser = (id, mobileNumber) => {
    const users = [...triviaShareAndPrivacy.sharedWithUsers];

    const newUsers = users.filter((x) => x.value != id);
    if (mobileNumber && mobileNumber.length > 0) {
      console.log("remove mobile number count -----", smsUsers);
      let userCellCount = smsUsers == 0 ? 0 : smsUsers - 1;
      console.log("after removed -----", userCellCount);

      setSmsUsers(userCellCount);
    }

    setTriviaShareAndPrivacy({
      ...triviaShareAndPrivacy,
      sharedWithUsers: [...newUsers],
    });

    // callApiToSaveData(newUsers, "REMOVE");
  };

  const onUserSelectAll = (u) => {
    if (u) {
      const onlySMSUsers = [...usersList].filter(
        (x) => x.mobileNumber && x.mobileNumber.length > 0
      );
      setSmsUsers(onlySMSUsers.length);
      setTriviaShareAndPrivacy({
        ...triviaShareAndPrivacy,
        sharedWithUsers: usersList,
      });
    } else {
      setSmsUsers(0);
      setTriviaShareAndPrivacy({
        ...triviaShareAndPrivacy,
        sharedWithUsers: [],
      });
    }
  };

  const viewMember = (u) => {
    let link = `/home/${user.profile.organizationId._id}/profile/${u.value}`;
    props.history.push(link);
  };

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  const tableCols = {
    user: shareTrivvyViaSMS ? 3 : 5,
    date: 3,
    action: 2,
    phoneNumber: 2,
    sharedVia: 2,
  };

  const { privacy, sharedWithUsers } = triviaShareAndPrivacy;
  console.log(
    "formData.questionsCount==null --- ",
    formData.questionsCount == null
  );

  const modalUI=()=>{
    return <div>
      <div className="my-3">
          <Alert className="my-2">
            Note: Trivvys are auto-published on the date(s) scheduled. To
            customize permissions and invite options (Email/SMS text), please go
            to the individual Trivvy page.
          </Alert>

          <div className="d-flex align-items-center">
            <div className="my-3">
              <Label>Select Number of Questions per Trivvy</Label>
              <Select
                value={formData.questionsCount}
                onChange={(e) => {
                  setFormData({ ...formData, questionsCount: e.value });
                }}
                options={questionOptions}
                placeholder="Select number of questions..."
              />
            </div>
          </div>
        </div>
        <div className="my-2">
          <Label>
            How many trivvys should be generated?{" "}
            {!formData.questionsCount ? (
              <small className="font-weight-bold">
                *note* please select number of questions first
              </small>
            ) : (
              ""
            )}{" "}
          </Label>
          <Select
            isDisabled={formData.questionsCount == null}
            disabled={formData.questionsCount == null}
            isReadOnly={formData.questionsCount == null}
            value={formData.noOfTrivvys}
            options={
              formData.questionsCount
                ? SELECT_NO_OF_TRIVVYS(Math.floor(20 / formData.questionsCount))
                : 0
            }
            onChange={(e) => {
              if (e) {
                const array = Array(e.value)
                  .fill()
                  .map((x, idx) => ({
                    name: `${library.name? library.name:""}Part - ${idx + 1}`,
                    scheduledDate: moment()
                      .add(1, "hour")
                      .startOf("hour"),
                    privacy: "PUBLIC",
                    sharedWithUsers: [],
                  }));
                setFormData({
                  ...formData,
                  noOfTrivvys: e.value,
                  trivvyParts: array,
                });
              } else {
                setFormData({
                  ...formData,
                  noOfTrivvys: null,
                });
              }
            }}
          />
        </div>
        <div className="my-3">
          <div className="mb-2">
            <Label>
              Schedule dates for Trivvys{" "}
              {!formData.noOfTrivvys ? (
                <small className="font-weight-bold">
                  *note* please select number of trivvys first
                </small>
              ) : (
                ""
              )}{" "}
            </Label>
          </div>

          <Alert color="info" className="my-2">
            If no date is selected, Trivvy will have scheduled date of today.
          </Alert>

          {formData.trivvyParts && formData.trivvyParts.length ? (
            <div>
              {formData.trivvyParts.map((item, index) => {
                return (
                  <Row className="my-3">
                    <Col md={7} xs={6}>
                      <div className="d-flex align-items-center">
                        <Input
                          value={item.name}
                          onChange={(e) => {
                            changeTrivvyName(e.target.value, index);
                          }}
                          placeholder={`Part ${index + 1}(Add Trivvy name)`}
                        />
                      </div>
                    </Col>
                    <Col md={5} xs={6}>
                      <ReactDatePicker
                        dateFormat="MM/DD/YYYY 𝖺𝗍 h:mm a"
                        id="actionDueDate"
                        placeholderText="Enter date: MM/DD/YYYY"
                        className="form-control filter-action-date-input"
                        minDate={new Date()}
                        minTime={
                        
                          item.scheduledDate &&
                          moment().isSame(moment(item.scheduledDate), "day")
                            ? moment().add(1,"hour")
                            : moment().startOf("day")
                        }
                        maxTime={moment().endOf("day")}
                        selected={
                          typeof item.scheduledDate == "string"
                            ? moment(item.scheduledDate)
                            : item.scheduledDate
                        }
                        onChange={(v) => {
                          if (v) {
                            const date = moment(v);
                            if(moment(date).startOf("day").isSame(date,"hour")){
                              // Future day @ midnight selected: default to 09:00:00 (TBV-624: 00 min, 00 sec)
                              changeTrivvyScheduledDate(date.add(9,"hours").startOf("hour"), index);
                            }else{
                              // Snap to the nearest quarter-hour (TBV: quarter-hour scheduling)
                              changeTrivvyScheduledDate(snapToQuarterHour(date), index);
                            }

                          } else {
                            changeTrivvyScheduledDate(null, index);
                          }
                        }}
                        showYearDropdown
                        showTimeSelect
                        timeFormat="h:mm a"
                        timeIntervals={15}
                      />
                    </Col>

                    {index != formData.noOfTrivvys - 1 && (
                      <hr className="my-2" />
                    )}
                  </Row>
                );
              })}
            </div>
          ) : (
            ""
          )}

          {/* <Button
            className="trivia-action-button-main"
            onClick={() => {
              const parts = [...formData.trivvyParts];

              if (parts.length < formData.noOfTrivvys) {
                parts.push({
                  name: "",
                  scheduledDate: null,
                });

                setFormData({
                  ...formData,
                  trivvyParts: parts,
                });
              }
            }}
          >
            Add New +
          </Button> */}
        </div>

        <div className="my-3">
          <div className="">
            <div>
              <Row className={`mt-4 share-quiz-privacy`}>
                <Col md={6}>
                  <div className="row text-left my-3">
                    <div className="col-md-5 col-lg-5 text-left sharePer-trivvy-txt">
                      Sharing Permissions:
                    </div>
                    <div className="col-md-7 col-lg-7 enterprise-settings-value">
                      <Select
                        className="pt-0"
                        value={triviaShareAndPrivacy.privacy}
                        onChange={(val) => {
                          setTriviaShareAndPrivacy({
                            ...triviaShareAndPrivacy,
                            privacy: val.value,
                          });
                        }}
                        options={TRIVIA_SHARE_PRIVACY_OPTIONS}
                        placeholder="Select Privacy"
                      />
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  {triviaShareAndPrivacy.privacy == "PUBLIC" && (
                    <div>
                      <div className="row text-left my-3">
                        <div className="col-md-5 col-lg-5 text-left">
                          User must provide:
                        </div>
                        <div className="col-md-7 col-lg-7 enterprise-settings-value">
                          <Select
                            className="pt-0"
                            value={userIdentification}
                            onChange={(val) => {
                              setUserIdentification(val.value);
                            }}
                            options={TRIVIA_USER_IDENTIFICATION_OPTIONS}
                            placeholder="Select User Identification"
                          />{" "}
                        </div>
                      </div>

                      <ReactTooltip />
                    </div>
                  )}
                </Col>
              </Row>
            </div>

            <div className={`mt-4`}>
              <div className="dFelxCenterWithGap">
                {" "}
                <h6>Invite Users</h6>{" "}
              </div>

              <div className={`my-1 share-quiz-privacy`}>
                <FormGroup
                  className={
                    isOwner
                      ? "disabled-change-permission mt40 share-quiz-privacy-form-css"
                      : "mt40 share-quiz-privacy-form-css"
                  }
                  row
                >
                  <Col sm={12} md={12} lg={12}>
                    <span
                      className="enterprise-setting-label"
                      style={{
                        fontSize: "14px",
                      }}
                    >
                      {allUsersChecked ? "Remove" : "Select"} all users{" "}
                    </span>
                    <CheckBox
                      checked={allUsersChecked}
                      onChange={(e) => {
                        setAllUsersChecked(!allUsersChecked);
                        onUserSelectAll(!allUsersChecked);
                      }}
                    />
                  </Col>

                  <Col sm={12} md={12} lg={12}>
                    <div
                      className="show_shared_trivvy_users"
                      style={{
                        overflow: "hidden",
                      }}
                    >
                      <div className="shareTableTrivia">
                        {!isMobile && (
                          <LayoutRow className="mobileNoheightActionTable">
                            <LayoutHeading
                              className="border justify-content-center bg-white"
                              colWidth={tableCols.user}
                              plainTable
                            >
                              User
                            </LayoutHeading>

                            <LayoutHeading
                              className="border justify-content-center bg-white"
                              colWidth={tableCols.date}
                              plainTable
                            >
                              Added On
                            </LayoutHeading>

                            {shareTrivvyViaSMS ? (
                              <LayoutHeading
                                className="border justify-content-center bg-white"
                                colWidth={tableCols.phoneNumber}
                                plainTable
                              >
                                Mobile Number
                              </LayoutHeading>
                            ) : null}

                            <LayoutHeading
                              className="border justify-content-center bg-white"
                              colWidth={tableCols.sharedVia}
                              plainTable
                            >
                              Shared Via
                            </LayoutHeading>

                            <LayoutHeading
                              className="border justify-content-center bg-white"
                              colWidth={tableCols.action}
                              plainTable
                            >
                              Action
                            </LayoutHeading>
                          </LayoutRow>
                        )}

                        <div
                          style={{
                            maxHeight:
                              sharedWithUsers && sharedWithUsers.length > 0
                                ? "300px"
                                : "0px",
                            overflowY: "auto",
                            overflowX: "hidden",
                            marginLeft: "-15px",
                          }}
                          className="hide-scroll w1scr"
                        >
                          {sharedWithUsers && sharedWithUsers.length > 0
                            ? sharedWithUsers.map((item) => {
                                const phoneNumberExists = usersListAll.find(
                                  (x) => x._id == item.value
                                );

                                console.log("itemmmmmmmmm____", item);
                                if (isMobile) {
                                  return (
                                    <LayoutData
                                      fullWidth
                                      className="col-pl-0 d-block bg-white"
                                    >
                                      <div
                                        style={{
                                          alignItems: "center",
                                          display: "flex",
                                        }}
                                        className="my-0 pl-2"
                                      >
                                        <div className="grp_member_profile_image cursor-pointer">
                                          {profilePicValidityCheck(
                                            item.profilePic
                                          ) ? (
                                            <div className="list-item__avatar">
                                              <img src={item.profilePic} />
                                            </div>
                                          ) : (
                                            <span
                                              className="list-item__avatar"
                                              data-letters={
                                                item.value == user.profile._id
                                                  ? getInitials(user.profile)
                                                  : getInitials(item)
                                              }
                                            ></span>
                                          )}
                                        </div>

                                        <div className="">
                                          <div
                                            className="linkedToolView"
                                            onClick={() => viewMember(item)}
                                          >
                                            {item.value == user.profile._id ? (
                                              "You"
                                            ) : (
                                              <span>
                                                {" "}
                                                {item.firstName} ,{" "}
                                                {item.lastName}
                                              </span>
                                            )}
                                          </div>
                                        </div>

                                        <Button
                                          onClick={() =>
                                            removeUser(
                                              item.value,
                                              item.mobileNumber
                                            )
                                          }
                                          color="danger"
                                          size="sm"
                                          className="ml-auto mr-3"
                                        >
                                          <BiTrashAlt size={12} />
                                        </Button>
                                      </div>
                                    </LayoutData>
                                  );
                                } else {
                                  return (
                                    <LayoutRow className="ml-0 mr-0">
                                      <LayoutData
                                        colWidth={tableCols.user}
                                        className="bg-white"
                                      >
                                        <div
                                          style={{
                                            alignItems: "center",
                                            display: "flex",
                                          }}
                                          className="my-0 pl-2"
                                        >
                                          <div className="grp_member_profile_image cursor-pointer">
                                            {profilePicValidityCheck(
                                              item.profilePic
                                            ) ? (
                                              <div className="list-item__avatar">
                                                <img src={item.profilePic} />
                                              </div>
                                            ) : (
                                              <span
                                                className="list-item__avatar"
                                                data-letters={
                                                  item.value == user.profile._id
                                                    ? getInitials(user.profile)
                                                    : getInitials(item)
                                                }
                                              ></span>
                                            )}
                                          </div>

                                          <div className="">
                                            <div
                                              className="linkedToolView"
                                              onClick={() => viewMember(item)}
                                            >
                                              {item.value ==
                                              user.profile._id ? (
                                                "You"
                                              ) : (
                                                <span>
                                                  {" "}
                                                  {item.firstName} ,{" "}
                                                  {item.lastName}
                                                </span>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </LayoutData>

                                      <LayoutData
                                        colWidth={tableCols.date}
                                        className="bg-white addedOnDateCss"
                                      >
                                        {moment(item.date).format(
                                          "h:mma on MMM D, YYYY"
                                        )}
                                      </LayoutData>
                                      {shareTrivvyViaSMS ? (
                                        <LayoutData
                                          colWidth={tableCols.phoneNumber}
                                          className="bg-white"
                                        >
                                          {item.mobileNumber &&
                                          item.mobileNumber.length > 0
                                            ? item.mobileNumber
                                            : "No"}
                                        </LayoutData>
                                      ) : null}

                                      <LayoutData
                                        colWidth={tableCols.sharedVia}
                                        className="bg-white"
                                      >
                                        {item.shareMediums &&
                                        item.shareMediums.length ? (
                                          <div className="trivvy-share-via-container">
                                            {item.shareMediums.includes(
                                              "EMAIL"
                                            ) && (
                                              <div>
                                                <BiMailSend
                                                  size={"17px"}
                                                  style={{ marginRight: "3px" }}
                                                />
                                                {/* <span className="font-13px">Emailed on {item.emailDate ?moment(item.emailDate).format("MM/DD/YYYY"):moment(item.date).format("MM/DD/YYYY")}</span>  */}
                                                <span className="font-13px">
                                                  {item.emailDate
                                                    ? moment(
                                                        item.emailDate
                                                      ).format("MM/DD/YYYY")
                                                    : moment(item.date).format(
                                                        "MM/DD/YYYY"
                                                      )}
                                                </span>
                                              </div>
                                            )}
                                            {item.shareMediums.includes(
                                              "SMS"
                                            ) && (
                                              <div>
                                                <MdOutlineMobileFriendly
                                                  size={"14px"}
                                                />
                                                {/* <span className="font-13px">SMS on {item.smsDate ? moment(item.smsDate).format("MM/DD/YYYY"):moment(item.date).format("MM/DD/YYYY")}</span>  */}
                                                <span className="font-13px">
                                                  {" "}
                                                  {item.smsDate
                                                    ? moment(
                                                        item.smsDate
                                                      ).format("MM/DD/YYYY")
                                                    : moment(item.date).format(
                                                        "MM/DD/YYYY"
                                                      )}
                                                </span>
                                              </div>
                                            )}
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </LayoutData>

                                      <LayoutData
                                        colWidth={tableCols.action}
                                        className="bg-white"
                                      >
                                        <Button
                                          onClick={() =>
                                            removeUser(
                                              item.value,
                                              item.mobileNumber
                                            )
                                          }
                                          color="danger"
                                          size="sm"
                                          style={{
                                            width: "40px",
                                          }}
                                        >
                                          <BiTrashAlt size={12} />
                                        </Button>
                                      </LayoutData>
                                    </LayoutRow>
                                  );
                                }
                              })
                            : ""}
                        </div>

                        <Row className="mr-0 px-0">
                          <ActionLayoutData
                            noDefault
                            className="col-pl-0 bg-white"
                            colWidth={12}
                          >
                            <Select
                              name="user-select"
                              placeholder={
                                "Start typing users name to add new..."
                              }
                              //value={newSelectedUser}
                              isOpen={true}
                              options={usersList.filter(
                                (x) =>
                                  !sharedWithUsers.some(
                                    (y) => y.value == x.value
                                  )
                              )}
                              onChange={(itm) => onUserSelect(itm)}
                              className={`trivia-user-share-select-row ${isMobile?"":"py-2"}`}
                              classNamePrefix="select"
                              open={true}
                            />
                          </ActionLayoutData>
                        </Row>
                      </div>
                    </div>
                  </Col>
                </FormGroup>
              </div>
            </div>

            <div className={`mt-4 mb-1 dFelxCenterWithGap`}>
              <h6>Share Via</h6>
              <div className="ml-2 d-flex text-left enterprise-setting-label">
                <div className="pr-2 enterprise-settings-value">
                  <CheckBox
                    checked={shareTrivvyViaEmail}
                    onChange={(e) => {
                      setShareTrivvyViaEmail(e.target.checked);
                    }}
                  />
                </div>
                <div className="text-left enterprise-setting-label">Email</div>
              </div>
              <div className="d-flex">
                <div className="pl-4 pr-2 text-left enterprise-settings-value">
                  <CheckBox
                    checked={shareTrivvyViaSMS}
                    onChange={(e) => {
                      setShareTrivvyViaSMS(e.target.checked);
                    }}
                  />
                </div>
                <div className="text-left enterprise-setting-label">
                  SMS ({smsUsers} of{" "}
                  {triviaShareAndPrivacy &&
                  triviaShareAndPrivacy.sharedWithUsers
                    ? triviaShareAndPrivacy.sharedWithUsers.length
                    : 0}{" "}
                  users)
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-3">
          <Label>Notify me when trivvys are published</Label>
          <CheckBox
            className="ml-3"
            checked={notifyAdminAfterTrivvyPublished}
            onChange={(e) => {
              setNotifyAdminAfterTrivvyPublished(e.target.checked);
            }}
          />
        </div>
    </div>
  }

  if(embeddedInTrivvyCreateModal){

    return <div>
      {modalUI()}

      <ModalFooter>
          <Button
            className="mr-4"
            onClick={() => {
             onBack()
            }}
          >
           Back
          </Button>
          <Button
            disabled={buttonDisabled()}
            color="success"
            className="mr-4 btn-success"
            onClick={() => {
              handleGenerateTrivvys();
            }}
          >
            Generate <FaArrowRight className="ml-2" />{" "}
          </Button>
        </ModalFooter>
    </div>

  }else{
    return (
      <Modal isOpen={open} className="lib-sch-modal-container">
        <ModalHeader toggle={onClose} className="trivia_modal_header_bg">
          Schedule Trivvy
        </ModalHeader>
  
        <ModalBody className={"p-3"}>
          {modalUI()}
        </ModalBody>
  
        <ModalFooter>
          <Button
            disabled={buttonDisabled()}
            color="success"
            className="mr-4 btn-success"
            onClick={() => {
              handleGenerateTrivvys();
            }}
          >
            Generate <FaArrowRight className="ml-2" />{" "}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLibraryScheduleLoader: (data) =>
      dispatch(actionCreators.setLibraryScheduleLoader(data)),
      setImportTemplateAddedTrivvys: (data) =>
      dispatch(actionCreators.setImportTemplateAddedTrivvys(data)),
    
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ScheduleQuestionsModal, axios));
